import React from "react";
import Toast from "@ingka/toast";
import "@ingka/toast/dist/style.css";
import { useDataContext } from "../../data-context/DataContextProvider";
import { useTranslation } from "@preppa/translation";

function ApiErrorToast() {
  const { apiError, dispatch } = useDataContext();
  const { translate } = useTranslation();

  return (
    <Toast
      isOpen={apiError !== null}
      text={apiError ? `${apiError.error}: ${apiError.message}` : ""}
      onCloseRequest={() => dispatch({ type: "CLEAR_API_ERROR" })}
      ariaLabelCloseBtn={translate("common.errors.dismissError")}
    />
  );
}

export default ApiErrorToast;
